import React from 'react';
import { observer } from 'mobx-react-lite';
import { appLocalStore } from '../stores/appLocalStore';

const ErrorsPanel: React.FC = observer(() => {
  const errors = appLocalStore.errors.slice();
  
  if (errors.length === 0) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-[1000] bg-black/80 backdrop-blur-sm">
      {errors.map((error, index) => (
        <div key={index} className="flex items-center justify-between px-5 py-3 bg-red-700 text-white border-b border-white/10 animate-[slideDown_0.3s_ease-out]">
          <span className="flex-1 text-sm font-medium">{error}</span>
          <button 
            className="bg-transparent border-none text-white text-2xl cursor-pointer p-0 ml-4 w-6 h-6 flex items-center justify-center opacity-80 transition-opacity hover:opacity-100"
            onClick={() => appLocalStore.dismissErrorAction(index)}
            aria-label="Dismiss error"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
});

export default ErrorsPanel;
